export default "__VITE_ASSET__CfyE8ldW__"